import { useState } from "react";
import { API_URL } from "../../../utils/common";

export interface AddUserPerfilRequest {
    nombre: string;
    descripcion: string;
    estatus: number;
}

export interface AddUserPerfilResponse {
    id: number;
    nombre: string;
    descripcion: string;
    estatus: number;
}

export const useAddUserPerfiles = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [perfil, setPerfil] =
        useState<AddUserPerfilResponse | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const agregarPerfil = async (
        payload: AddUserPerfilRequest
    ): Promise<AddUserPerfilResponse | null> => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(
                `${API_URL}/cms/admin/perfiles`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        nombre: payload.nombre,
                        descripcion: payload.descripcion,
                        estatus: payload.estatus,
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Error al agregar el perfil");
            }

            const data: AddUserPerfilResponse =
                await response.json();

            setPerfil(data);

            return data;

        } catch (err: any) {

            console.error(err);

            setError(
                err.message || "Ocurrió un error"
            );

            return null;

        } finally {

            setLoading(false);

        }

    };

    return {
        perfil,
        loading,
        error,
        agregarPerfil,
    };

};